import { css, Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { Link } from "../Link";

const breakMobile = "only screen and (min-width: 500px)";
const createLinkStyles = (props: { theme: Theme }) => `
  border-bottom: 1px solid transparent;
  color: ${props.theme.colors.cloudDark};
  padding: 0 0 2px;
  text-decoration: none;
  transition: border 0.3s;

  &:hover {
    border-bottom-color: ${props.theme.colors.cloudDark};
  }

  &[data-flag="true"] span {
    display: inline-block;
    background-repeat: no-repeat;
    background-size: cover;
    height: 10px;
    width: 15px;
  }
`;

export const CopyRightHeaderWrapper = styled.li<{
  showChangeLocation: boolean;
}>`
  ${(props) =>
    !props.showChangeLocation
      ? `display: block;
     width: 100%;`
      : ""}
`;

export const CopyRightHeader = styled.h5`
  font-weight: 400;
  color: ${(props) => props.theme.colors.snowdrop};
  margin-right: 16px;
  white-space: nowrap;
`;

export const FWrapper = styled.footer`
  background: ${(props) => props.theme.colors.charcoal};
  overflow: visible;
  position: relative;
  padding: 48px 0px;
  color: ${(props) => props.theme.colors.cloudDark};

  @media ${breakMobile} {
    padding: 48px 24px;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    padding: 60px 44px;
  }

  @media ${(props) => props.theme.bp.desktopUp} {
    padding: 104px 84px;
  }
`;

export const FInnerWrapper = styled.div`
  margin: 0 auto;
  max-width: ${(props) => props.theme.variables.extraLargeMaxWidth};
`;

export const FooterBoxWrapper = styled.div`
  @media ${(props) => props.theme.bp.tabletUp} {
    display: table-cell;
    width: 33%;
  }

  @supports (display: grid) {
    @media ${(props) => props.theme.bp.tabletUp} {
      display: block;
      width: auto;
    }
  }
`;

export const FooterBox = styled.ul`
  color: ${(props) => props.theme.colors.snowdrop};
  margin: 0;
  padding-left: 0;
  margin-bottom: 24px;

  @media ${breakMobile} {
    margin-bottom: 24px;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    margin-bottom: 48px;
  }

  @supports (display: grid) {
    @media ${(props) => props.theme.bp.tabletUp} {
      display: block;
      width: auto;
    }
  }
`;

export const FooterBoxHeader = styled.h5`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const FooterItem = styled.li`
  display: flex;
  align-items: center;
  line-height: 1.3;
  padding: 4px 0;
`;

export const FooterLinkItem = styled(FooterItem)`
  margin-bottom: 4px;
`;

export const FooterItemTrustPilot = styled(FooterLinkItem)`
  margin-top: 32px;
`;

export const FooterLink = styled.a`
  ${(props) => createLinkStyles(props)}
`;
export const ChangeLocation = styled(FooterLink)`
  border: 2px solid ${(props) => props.theme.colors.charcoalLight};
  background: ${(props) => props.theme.colors.charcoal};
  padding: 16px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-bottom-color: ${(props) => props.theme.colors.charcoalLight};
  }
`;

export const ChangeLocationLink = styled(FooterLink)`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-bottom-color: transparent;
  }
`;

export const LocationFlag = styled.span`
  width: 28px !important;
  height: 18px !important;
  margin-right: 12px;
`;

export const StyledFooterLink = styled(Link)`
  ${(props) => createLinkStyles(props)}
`;

export const StyledFooterSigninLink = styled("a")`
  ${(props) => createLinkStyles(props)}
`;

export const BCorpLogosWrapper = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  align-items: ${({ $isMobile }) => ($isMobile ? "flex-start" : "center")};
  gap: 11px;

  /* margin-left: ${({ $isMobile }) => ($isMobile ? "0px" : "22px")}; */
  margin-top: ${({ $isMobile }) => ($isMobile ? "-32px" : "0")};
`;

export const BCorpLogoWrapper = styled.div<{ $isCertifiedLogo?: boolean }>`
  width: 90px;
  ${({ $isCertifiedLogo }) =>
    $isCertifiedLogo
      ? css`
          width: 90px;
        `
      : undefined};
`;

export const EcoSystemLogoWrapper = styled.span`
  margin-left: -16px;
`;

export const FooterDivider = styled.div`
  max-width: calc(100vw - 48px);
  width: 100%;
  height: 0px;
  border: 2px solid ${(props) => props.theme.colors.charcoalLight};
  margin: 0 0 24px 16px;

  @media ${breakMobile} {
    margin: 0;
    margin-bottom: 48px;
    padding-left: 0;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    max-width: 1224px;
  }
`;

export const FooterGrid = styled.div`
  @media ${(props) => props.theme.bp.tabletUp} {
    display: table;
    width: 100%;
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr;

    @media ${breakMobile} {
      grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr);
    }

    @media ${(props) => props.theme.bp.tabletUp} {
      grid-gap: 20px;
    }

    @media ${(props) => props.theme.bp.desktopUp} {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;

export const PolicyWrapper = styled.ul`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;

  & > li {
    margin-right: 16px;
  }
`;

export const LogosWrapper = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  align-items: ${({ $isMobile }) => ($isMobile ? "flex-start" : "center")};
  transform: translateX(-16px);
  margin-top: -8px;

  @media ${breakMobile} {
    margin-top: 16px;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    margin: 0;
    flex-direction: row;
    justify-content: center;
  }
`;

export const PolicySectionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
`;

export const WrapperInner = styled.div`
  margin: 0 auto;

  @media ${breakMobile} {
    transform: translateX(-16px);
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    transform: translateX(0);
  }
`;

export const LogoLinkWrapper = styled.div`
  display: flex;
  margin-right: 0px;
  padding-left: 16px;
  max-height: 70px;

  @media ${breakMobile} {
    padding-left: 0;
    margin-right: 80px;
    max-width: 100px;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    max-width: 100%;
    margin-right: 170px;
  }
`;

export const LogoImage = styled.img`
  max-width: 100px;
  margin-bottom: 12px;

  @media ${(props) => props.theme.bp.tabletUp} {
    max-width: none;
  }
`;

export const SectionAboveDivider = styled.div`
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.bp.tabletUp} {
    flex-direction: row;
  }
`;

export const SectionBelowDivider = styled(SectionAboveDivider)`
  justify-content: space-between;
  padding-left: 16px;

  @media ${breakMobile} {
    padding-left: 0;
  }
`;

export const BCorpLogo = styled.img`
  width: 100%;
`;
